import React, { useState, useRef } from 'react';
import { useCompleteProfileMutation } from '../../redux/auth/authApiSlice';
import { useDispatch, useSelector } from 'react-redux';
import { setCredentials, selectCurrentUser } from '../../redux/auth/authSlice';
import { useNavigate } from 'react-router-dom';
import styles from './styles.module.css';

const OtpStep = ({ userId, phone }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentUser = useSelector(selectCurrentUser);
  const [otp, setOtp] = useState('');
  const [firstName, setFirstName] = useState(currentUser?.firstName || '');
  const [lastName, setLastName] = useState(currentUser?.lastName || '');
  const [error, setError] = useState('');
  const [info, setInfo] = useState('');
  const [completeProfile, { isLoading }] = useCompleteProfileMutation();
  const otpRef = useRef();

  // Krav om namn saknas sedan tidigare
  const requireFirst = !currentUser?.firstName?.trim();
  const requireLast = !currentUser?.lastName?.trim();

  const onOtpChange = (val) => {
    const onlyDigits = val.replace(/\D/g,'').slice(0,6);
    setOtp(onlyDigits);
    if (error) setError('');
  };

  const onPasteOtp = (e) => {
    const text = (e.clipboardData.getData('text')||'').replace(/\D/g,'').slice(0,6);
    if (text) {
      e.preventDefault();
      setOtp(text);
    }
  };

  const submit = async (e) => {
    e.preventDefault();
    setError(''); setInfo('');
    if (otp.length !== 6) { setError('Fel kod'); return; }
    if (requireFirst && !firstName.trim()) { setError('Förnamn krävs'); return; }
    if (requireLast && !lastName.trim()) { setError('Efternamn krävs'); return; }
    try {
      const data = await completeProfile({ userId, otp, firstName: firstName.trim(), lastName: lastName.trim() }).unwrap();
      dispatch(setCredentials(data));
      setInfo('Profil klar du navigeras till login skärmen');
      setTimeout(()=> navigate('/start', { replace:true }), 1600);
    } catch (err) {
      if (err?.status === 400) setError('Fel kod');
      else if (err?.status === 404) { setError('Användare saknas'); }
      else setError('Tekniskt fel');
    }
  };

  return (
    <form onSubmit={submit} className={`${styles.pc_form} ${styles.fade_in}`}>
      <h2 className={styles.pc_header}>Verifiera kod</h2>
      <p className={styles.pc_sub}>Skickad till {phone}</p>
      <input
        ref={otpRef}
        className={`${styles.pc_input} ${styles.pc_otp}`}
        placeholder="______"
        value={otp}
        onChange={e=>onOtpChange(e.target.value)}
        onPaste={onPasteOtp}
        inputMode="numeric"
        autoComplete="one-time-code"
        maxLength={6}
      />
      <input className={styles.pc_input} placeholder="Förnamn" value={firstName} onChange={e=>setFirstName(e.target.value)} required={requireFirst} />
      <input className={styles.pc_input} placeholder="Efternamn" value={lastName} onChange={e=>setLastName(e.target.value)} required={requireLast} />
      {error && <div className={styles.pc_error}>{error}</div>}
      {info && <div className={styles.pc_info}>{info}</div>}
      <div className={styles.pc_actions}>
        <button type="submit" className={styles.pc_button_primary} disabled={isLoading || otp.length!==6}>{isLoading ? 'Verifierar...' : 'Verifiera'}</button>
        <div className={styles.pc_help}>Har du inte fått koden? Vänta några sekunder och försök igen från föregående steg.</div>
      </div>
    </form>
  );
};
export default OtpStep;
